export default "__VITE_ASSET__DHngDcVp__"